import { NewsArticle } from "./newsArticle";

export class SectionArticle {
  section: string;
  sectionDescription: string;
  totalViews: number;
  publishedDateInMS: number;
  newsArticles: NewsArticle[];

  constructor(section: string, 
              sectionDescription: string,
              totalViews: number,
              publishedDateInMS: number,
              newsArticles: NewsArticle[]) {
    this.section = section;
    this.sectionDescription = sectionDescription;
    this.totalViews = totalViews;
    this.publishedDateInMS = publishedDateInMS;
    this.newsArticles = newsArticles;
  }
}